import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { UI_VERSION, IS_CLIENT, HOSTNAME } from '@constants';
import { Loader } from '@components/Loader';
import { MainHead } from './Main-Head';
import { ui } from './ui';

export const PreviewLayout = ({ children }) => {
  const { locale } = useSelector((state) => state.settings);
  const { translations } = children.props;
  useEffect(() => {
    if (IS_CLIENT) {
      const script = document.createElement('script');

      script.src = `https://ui.${HOSTNAME}/static/js/site.js?v${UI_VERSION}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = () => {
        ui.connectTranslations();
        ui.initObserver({ locale });
        ui.initGallery({ locale });
        ui.initEstimateListeners({ locale });
      };
    }
  }, []);

  return (
    <>
      <MainHead
        title={translations.t(`site.preview.meta.title`)}
        description={translations.t(`site.preview.meta.description`)}
      />
      <main>{children}</main>
      <Loader />
    </>
  );
};
